const Footer = () => {
    return (
        <footer>
            <div className="container">
                <div className="row">
                    <p className="copyright text-muted" style={{ textAlign: "right" }}>2016 &copy; ihongss.com</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;